import React, { PureComponent } from 'react'
import { TableRow, TableCell, TextField } from '@material-ui/core'

export class PricesBodyRowBase extends PureComponent {
  onChange = id => e => {
    const { changePrice } = this.props

    const value = e.target.value

    changePrice({ id, value })
  }

  onBlur = (id, returned) => e => {
    const { setPrice } = this.props

    const value = e.target.value

    setPrice({ id, value, returned })
  }

  renderPriceCell = ({ price, id, returned }, index) => {
    const { classes, data } = this.props

    const firstCell = index === 0
    const lastCell = data.length === index + 1

    return firstCell
      ? (
        <TableCell
          key={id}
          padding='dense'
          className={classes.tableCell}
        >
          {id}
        </TableCell>
      )
      : (
        <TableCell
          key={id}
          className={classes.tableCell}
          padding={lastCell ? 'dense' : 'none'}
        >
          {price === '-'
            ? price
            : (
              <TextField
                value={price}
                onBlur={this.onBlur(id, returned)}
                padding='none'
                onChange={this.onChange(id)}
                className={classes.sourceField}
                inputProps={{
                  className: classes.sourceInput
                }}
              />
            )}
        </TableCell>
      )
  }

  render() {
    const { classes, data } = this.props

    return (
      <TableRow className={classes.tableRow}>
        {data.map(this.renderPriceCell)}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Prices/components/PricesBodyRow/PricesBodyRow.js